import { Loader2 } from "lucide-react";

const SIZE = {
  sm: { ring: "h-5 w-5", icon: "size-3" },
  md: { ring: "h-10 w-10", icon: "size-5" },
  lg: { ring: "h-16 w-16", icon: "size-8" },
} as const;

type LimeSpinnerProps = {
  size?: keyof typeof SIZE;
  /** `lime` for overlays; `current` inherits button/text colour. */
  color?: "lime" | "current";
  className?: string;
  /** Hide from AT when a parent already announces loading. */
  decorative?: boolean;
};

export default function LimeSpinner({
  size = "lg",
  color = "lime",
  className = "",
  decorative = false,
}: LimeSpinnerProps) {
  const { ring, icon } = SIZE[size];
  const isLime = color === "lime";

  return (
    <span
      className={`relative inline-flex shrink-0 items-center justify-center align-middle ${ring} ${className}`}
      {...(decorative
        ? { "aria-hidden": true }
        : { role: "status", "aria-label": "Loading" })}
    >
      <span
        className={`absolute inset-0 rounded-full border-2 ${
          isLime ? "border-[#D4FF00]/20" : "border-current/20"
        }`}
      />
      <Loader2
        className={`${icon} animate-spin ${isLime ? "text-[#D4FF00]" : "text-current"}`}
        aria-hidden
      />
    </span>
  );
}
